<template>
    <v-dialog :value="value" @input="(val) => {$emit('input', val)}" max-width="800">
        <v-stepper v-model="step">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1">
                    Gegevens
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2">
                    Resultaat
                </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
            <v-stepper-content step="1">
                <div class="px-2 py-2 mb-4">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-select class="mb-4" :rules="[val => $validator.required(val, 'Module selecteren')]" :disabled="importLoading" v-model="selectedModule" return-object :items="modules" dense
                            outlined item-value="unique" item-text="endpoint" label="Wat wilt u importeren?">
                            <template v-slot:selection="data">
                                <div class="d-flex align-center">
                                    <v-icon left v-html="data.item.icon"></v-icon>
                                    <span>{{ $t(data.item.unique) }}</span>
                                </div>
                            </template>
                            <template v-slot:item="data">
                                <v-list dense class="py-0">
                                    <v-list-item class="px-0">
                                        <v-list-item-icon class="mr-2">
                                            <v-icon v-html="data.item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t(data.item.unique) }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </template>
                        </v-select>
                        <!-- zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed, -->
                        <v-file-input :rules="[val => $validator.required(val, 'Bestand selecteren')]" dense outlined v-model="selectedFile" :disabled="importLoading" label="Bestand selecteren (.xlsx)" truncate-length="50" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,xlsx" prepend-icon="mdi-archive-arrow-up"></v-file-input>
                    </v-form>
                </div>
                <v-divider></v-divider>
                <div class="px-2 py-2 d-flex">
                    <v-btn text @click="$emit('input', false)">Annuleren</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="importItems" :loading="importLoading">
                            Volgende
                        </v-btn>
                </div>
            </v-stepper-content>
            <v-stepper-content step="2">
                <div class="px-2 py-2 mb-4" v-if="selectedModule">
                    <h2>{{$t(selectedModule.unique)}} zijn geïmporteerd!</h2>
                    <eod-expansion-panels class="eod-expansion-panels-no-inset mt-4">
                        <v-expansion-panel v-if="importResult.errors && importResult.errors[0]">
                            <v-expansion-panel-header class="error lighten-5"><strong>Fouten ({{ importResult.errors.length }})</strong></v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-data-table dense :headers="getAllHeaders(importResult.errors[0])" :items="importResult.errors"></v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel v-if="importResult.updated && importResult.updated[0]">
                            <v-expansion-panel-header>Aangepast ({{ importResult.updated.length }})</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-data-table dense :headers="getAllHeaders(importResult.updated[0])" :items="importResult.updated"></v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel v-if="importResult.created && importResult.created[0]">
                            <v-expansion-panel-header>Aangemaakt ({{ importResult.created.length }})</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-data-table dense :headers="getAllHeaders(importResult.created[0])" :items="importResult.created"></v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </eod-expansion-panels>
                </div>
                <v-divider></v-divider>
                <div class="px-2 py-2 d-flex">
                    <v-btn text @click="$emit('input', false)">
                            Sluiten
                        </v-btn>
                </div>
            </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-dialog>
</template>
<script>
    export default {
        props:{
            value: Boolean
        },
        data: () => ({
            // General
            step: 1,
            valid: true,
            settings: require('./../classes/settings.js'),

            // Data
            selectedModule: null,
            selectedFile: null,
            modules: [],

            // Export
            importLoading: false,
            importResult: {},
        }),
        created(){
            for (const moduleKey in this.settings.modules) {
                const moduleInfo = this.settings.modules[moduleKey];
                if(moduleInfo.canImport){
                    if (moduleInfo.model && moduleInfo.model.exportFields) {
                        this.modules.push({
                            unique: moduleKey,
                            ...moduleInfo
                        });
                    }
                }
            }
        },
        methods:{
            getAllHeaders(item){
                const headers = [
                    {
                        value: 'index',
                        text: 'Rij'
                    },
                ];

                if(item.message){
                    headers.push({
                        value: 'message',
                        text: 'Fout'
                    });
                }

                for (const propertyName in item.data) {
                        headers.push({
                            value: 'data.'+propertyName,
                            text: propertyName
                        });
                    }
                
                return headers;
            },
            importItems(){
                if(this.$refs.form.validate()){
                    this.importLoading = true;

                    this.$eod.import(this.selectedModule, this.selectedFile).then(response => {
                        this.importResult = response.data;
                    }).catch(e => {
                        this.importResult = {errors:[{message:e}]};
                    }).finally(() => {
                        this.importLoading = false;
                        this.step = 2;
                    });

                }
            }
        }
    }
</script>